/**
 * 返回一个延迟更新的值。
 * 每当 value 在 delay 毫秒内再次变化，旧计时器会取消并重新计时。
 * 本项目用它给加载页、声音选择页和贺卡关闭动画留出过渡时间。
 */
import { useState, useEffect } from 'react';

export function useDebounce<T = any>(value: T, delay: number) {
    // debouncedValue 保存“已经稳定了一段时间”的旧值。
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(
        () => {
            // value 保持不变达到 delay 后，才把新值发布给使用方。
            const handler = setTimeout(() => {
                setDebouncedValue(value);
            }, delay);

            // value/delay 改变或组件卸载时清理旧计时器，防止过期更新和内存泄漏。
            return () => {
                clearTimeout(handler);
            };
        },
        // value 或 delay 变化时重新开始等待。
        [value, delay],
    );

    return debouncedValue;
}
